'use strict';

var React = require('react');

var SvgInventoryMajor = function SvgInventoryMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.838 5.455a1 1 0 0 0-.432-.369l-9-4a.999.999 0 0 0-.812 0l-9 4a1 1 0 0 0-.594.914v14h2v-13.35l8-3.556 8 3.556v13.35h2v-14a1 1 0 0 0-.162-.545zm-7.838 2.545h4v4h-4v-4zm-2 2h-6v10h6v-10zm6 4h-4v6h4v-6z"
  }));
};

exports.SvgInventoryMajor = SvgInventoryMajor;
